<form>
  <spk-card title="Search Countries">
    <spk-checkbox wrappedClass="pull-right" name="showInactive" [(model)]="showInactive" (modelChange)="setFilterSpecification()"></spk-checkbox>
    <spk-search-grid #grid defaultSortProperty="Name ASC" list="CountrySearchRow" [leftLinks]="leftLinks" [filter]="filter"></spk-search-grid>
  </spk-card>
</form>